module.exports = __webpack_public_path__ + "static/7651_Fairoaks_Dr-ce5ca23820d74ffbb3f045be5a69cb50.webp";